module.exports = __webpack_public_path__ + "r-v3/img/ico_check_black.9e7207ba.svg";